module.exports = __webpack_public_path__ + "img/settings.94a96287.png";